var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavourite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.647 7.017h-6.225L8.5 1.097l-1.923 5.92H.353l5.035 3.658-1.922 5.92L8.5 12.936l5.035 3.659-1.922-5.92zm-5.014 6.96L8.5 11.699l-3.133 2.277 1.197-3.685-3.133-2.274h3.873L8.5 4.333l1.196 3.684h3.873l-3.133 2.275z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavourite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favourite.svg";